export type ForecastOverTargetCellNotification = {
  status?: number;
  message?: string | null;
  groupMessage?: string | null;
  isForecastOverTarget?: boolean;
};

export const isForecastOverTargetNotification = (
  notification: ForecastOverTargetCellNotification | null | undefined
): boolean => Boolean(notification?.isForecastOverTarget);
